import { useEffect, useState } from 'react';
import Select from 'react-select';

import styles from './styles.module.css';
import React from 'react';
import { useFindOptionsEffect } from './src/find-options-effect';

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: '#D9D9D980',
  color: 'var(--black-400)',
  fontWeight: 'bold',
  textTransform: 'capitalize',
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
  </div>
);

/**
 * Componente que utiliza lib Select2
 * 
 * @param {onFocus} param0 
 * @returns 
 */
const Select2 = ({onFocus, onBlur, handleChange, style, handleFindOptions, noOptionsMessage, className, ...restProps}) => {
  const [styleFocus, setStyleFocus] = useState({});
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(restProps.options ?? []);
  const [searchValue, setSearchValue] = useState('');
 
  useFindOptionsEffect(searchValue, handleFindOptions, setOptions, setLoading, restProps.name);

  const handleInputChange = (inputValue, { action }) => {
    if (action === 'input-change') {
      setSearchValue(inputValue);
    }
  };

  // const handleChangeOpcaoSelecionada   = (opcaoSelecionada) => {
  //   setValue(opcaoSelecionada?.label);
  //   handleChange(opcaoSelecionada);
  // }

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 40,
    }),
  };

  const focus = (event) => {
    if (onFocus) {
      onFocus(event);
    }
    setStyleFocus({
      border: '1px solid red !important',
      boxShadow: `0 0 0.5rem red !important`,
      outline: 0,
    });
  };

  const blur = (event) => {
    if (onBlur) {
      onBlur(event);
    }
    setStyleFocus({});
  };

  const customLoadingMessage = () => 'Carregando...';

  // Função para personalizar a mensagem quando não há opções
  const handleNoOptionsMessage = ({ inputValue }) =>
    inputValue ? noOptionsMessage : 'Digite para buscar opções';

  return (
    <>
      <Select
        id={restProps.id}
        styles={{ ...customStyles, ...styleFocus, ...style }}
        className={`${styles.select} ${className}`}
        options={options}
        onFocus={focus}
        onBlur={blur}
        required={restProps.required ?? false}
        isClearable={restProps.isClearable ?? true}
        isSearchable={restProps.isSearchable ?? true}
        isDisabled={restProps.isDisabled ?? false}
        isLoading={restProps.isLoading ?? loading}
        loadingMessage={customLoadingMessage}
        isRtl={restProps.isRtl ?? false}
        name={restProps.name ?? 'select'}
        onInputChange={handleInputChange}
        onChange={handleChange}
        formatGroupLabel={formatGroupLabel}
        noOptionsMessage={handleNoOptionsMessage}
        placeholder={
          restProps.placeholder ? restProps.placeholder : 'Selecione uma opção'
        }
        defaultValue={restProps?.options?.filter(option => 
          option?.label === restProps?.defaultValue)??[]}
      />
    </>
  );
};

export default Select2;
